import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Typography,
  List,
  Card,
  Input,
  Modal,
  Button,
  Popover,
  Layout,
  Checkbox,
  Skeleton,
  Table,
  Spin,
  Select,
  Image,
  Pagination,
  DatePicker,
  message as messageApi,
} from "antd";
import dayjs from "dayjs";
import { UserOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { FaSearch, FaFilter, FaCaretDown, FaEye, FaDownload } from "react-icons/fa";
import { AiOutlineEye } from "react-icons/ai";
import ClientLayout from "../../components/ClientLayout";
import { Get } from "../../config/api/get";
import { LESSON, QUIZ, USERS } from "../../config/constants/api";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import html2pdf from "html2pdf.js";

function AttemptedQuizzes() {
  const token = useSelector((state) => state.user.userToken);
  const user = useSelector((state) => state.user.userData);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [lessons, setLessons] = useState([]);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedAttempt, setSelectedAttempt] = useState(null);
  const [quizDetails, setQuizDetails] = useState(null);
  const [loadingQuizDetails, setLoadingQuizDetails] = useState(false);
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const navigate = useNavigate();

  const [filter, setFilter] = useState({
    status: null,
    type: null,
    keyword: "",
    from: null,
    to: null,
  });

  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const message = `Showing records ${endIndex} of ${paginationConfig.totalDocs}`;

  useEffect(() => {
    getLessons();
  }, []);

  console.log(lessons, "lessons");

  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });

    getLessons(pageNumber);
  };

  const handleSearch = (value) => {
    setFilter({
      ...filter,
      keyword: value,
    });
  };

  const handleStatusChange = (value) => {
    setFilter({
      ...filter,
      status: value,
    });
  };

  const handleTypeChange = (value) => {
    setFilter({
      ...filter,
      type: value,
    });
  };

  const resetFilter = () => {
    setFilter({
      status: null,
      keyword: "",
      from: null,
      to: null,
    });
    getLessons(paginationConfig.pageNumber, paginationConfig.limit, "", true);
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleFrom = (date) => {
    setFilter({
      ...filter,
      from: date,
    });
  };

  const handleTo = (date) => {
    setFilter({
      ...filter,
      to: date,
    });
  };

  const handleViewQuiz = async (attempt) => {
    setSelectedAttempt(attempt);
    setViewModalOpen(true);
    setLoadingQuizDetails(true);
    try {
      const response = await Get(QUIZ.getQuizById + attempt.quiz._id, token);
      if (response?.status) {
        setQuizDetails(response?.data);
      } else {
        messageApi.error("Failed to load quiz details");
      }
    } catch (error) {
      console.log(error.message);
      messageApi.error("Error loading quiz details");
    } finally {
      setLoadingQuizDetails(false);
    }
  };

  const handleDownloadQuiz = async () => {
    const content = document.getElementById("quiz-print-content");
    if (!content) {
      messageApi.error("Certificate content not found");
      return;
    }

    try {
      messageApi.loading({ content: "Generating PDF...", key: "pdf", duration: 0 });
      
      const opt = {
        margin: [5, 5, 5, 5],
        filename: `Certificate_${selectedAttempt?.quiz?.title?.replace(/\s+/g, "_") || "Quiz"}_${dayjs(selectedAttempt?.createdAt).format("YYYY-MM-DD")}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { 
          scale: 2,
          useCORS: true,
          letterRendering: true,
        },
        jsPDF: { 
          unit: "mm", 
          format: "a4", 
          orientation: "portrait" 
        },
        pagebreak: { mode: ["avoid-all", "css", "legacy"] }
      };

      await html2pdf().set(opt).from(content).save();
      
      messageApi.success({ content: "Certificate downloaded successfully!", key: "pdf" });
    } catch (error) {
      console.error("Error generating PDF:", error);
      messageApi.error({ content: "Failed to download certificate. Please try again.", key: "pdf" });
    }
  };

  const handleCloseModal = () => {
    setViewModalOpen(false);
    setSelectedAttempt(null);
    setQuizDetails(null);
  };

  const handleLimitChange = (pageSize) => {
    setPaginationConfig({
      ...paginationConfig,
      limit: pageSize,
      current: 1,
    });

    getLessons(1, pageSize);
  };

  const getLessons = async (pageNumber, pageSize, search, reset = false) => {
    setLoading(true);
    try {
      const response = await Get(QUIZ.getMyAttempts, token, {
        page: pageNumber
          ? pageNumber.toString()
          : paginationConfig.pageNumber.toString(),
        limit: pageSize
          ? pageSize.toString()
          : paginationConfig.limit.toString(),
        status: reset ? "" : filter.status || null,
        type: reset ? "" : filter.type || null,
        keyword: search ? search : null,
        from: reset ? "" : filter?.from ? filter?.from.toISOString() : "",
        to: reset ? "" : filter?.to ? filter?.to.toISOString() : "",
      });
      setLoading(false);
      if (response?.status) {
        setLessons(response?.data?.docs);
        setPaginationConfig({
          pageNumber: response?.data?.page,
          limit: response?.data?.limit,
          totalDocs: response?.data?.totalDocs,
          totalPages: response?.data?.totalPages,
        });
      } else {
        messageApi.error(response.message);
        console.log("error====>", response);
      }
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };

  console.log("paginationConfig", paginationConfig);

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return originalElement;
  };

  const columns = [
    {
      title: "S. No.	",
      dataIndex: "key",
      key: "key",
      width: 100,
      render: (value, item, index) => (index < 9 && "0") + (index + 1),
    },
    {
      title: "Quiz ID",
      dataIndex: ["quiz", "_id"],
      key: "quiz",
      render: (item) => "#" + item?.slice(-4),
    },
    {
      title: "Quiz Title",
      dataIndex: ["quiz", "title"],
      key: "quiz",
      render: (item) => <span>{item}</span>,
    },
    {
      title: "Passing Percentage",
      dataIndex: ["quiz", "passingPercentage"],
      key: "quiz",
      render: (item) => <span>{item}</span>,
    },
    {
      title: "Your Score",
      dataIndex: "score",
      key: "score",
      render: (item) => <span>{item}</span>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (item) => <span>{item}</span>,
    },
    {
      title: "Actions",
      key: "actions",
      width: 220,
      render: (_, record) => (
        <div style={{ display: "flex", gap: 8 }}>
          {record.status === "PASSED" && (<Button
            type="primary"
            icon={<FaEye />}
            onClick={() => handleViewQuiz(record)}
            style={{ backgroundColor: "#00a79d" }}
          >
            View Certificate
          </Button>)}
          {record.status === "FAILED" && (
            <Button
              type="primary"
              onClick={() => {
                navigate(`/quiz-details/${record.quiz._id}`);
              }}
              style={{
                backgroundColor: "#00a79d",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Re-Attempt
            </Button>
          )}
        </div>
      ),
    },
  ];

  const filterContent = (
    <div className="filterDropdown">
      <div>
        <p className="mainLabel" style={{ padding: "10px" }}>
          Filter
        </p>
      </div>
      <hr style={{ margin: 0 }} />

      <div className="filterDropdownBody">
        <p className="mainLabel">Lesson Date:</p>
        <DatePicker
          className="mainInput filterInput"
          value={filter.from}
          onChange={(e) => handleFrom(e)}
          placeholder="From"
        />
        <DatePicker
          className="mainInput filterInput"
          value={filter.to}
          onChange={(e) => handleTo(e)}
          placeholder="To"
        />

        <p className="mainLabel">Lesson Type:</p>

        <Select
          size={"large"}
          className="filterSelectBox"
          placeholder="Select Lesson Type"
          value={filter.type}
          onChange={(e) => handleTypeChange(e)}
          style={{
            width: "100%",
            marginBottom: "10px",
            textAlign: "left",
          }}
          options={[
            { value: "TUTORING", label: "Training" },
            { value: "COACHING", label: "Consulting" },
          ]}
        />

        <p className="mainLabel">Status:</p>

        <Select
          size={"large"}
          className="filterSelectBox"
          placeholder="Select Status"
          value={filter.status}
          onChange={(e) => handleStatusChange(e)}
          style={{
            width: "100%",
            marginBottom: "10px",
            textAlign: "left",
          }}
          options={[
            { value: "PENDING", label: "Pending" },
            { value: "UPCOMING", label: "Upcoming" },
          ]}
        />

        <Button
          type="primary"
          block
          size={"large"}
          style={{ marginBottom: "10px" }}
          className="loginButton"
          onClick={() => getLessons()}
        >
          Apply
        </Button>
        <Button
          type="primary"
          block
          size={"large"}
          className="loginButton"
          onClick={() => resetFilter()}
        >
          Clear All
        </Button>
      </div>
    </div>
  );
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Row
        className="upcomingBackground"
        style={{
          height: "55vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography.Title
          className="fontFamily1 upcomingBackground-content"
          style={{ fontSize: "30px", color: "#000" }}
        >
          {<>My Quiz Attempts</>}
        </Typography.Title>
      </Row>

      {/* section 2 */}
      <Row
        className="whiteBackground"
        style={{ backgroundColor: "white", justifyContent: "center" }}
      >
        <Col xs={24} md={22}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              padding: "100px 20px",
            }}
          >
            <Card
              className="infoBox"
              bordered={false}
              style={{
                width: "100%",
                padding: "20px",
              }}
            >
              <div className="boxDetails">
                <Row style={{ padding: "10px 20px" }}>
                  <Col xs={24} md={12}></Col>
                  <Col
                    xs={24}
                    md={12}
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    <Popover
                      content={filterContent}
                      trigger="click"
                      open={open}
                      onOpenChange={handleOpenChange}
                      placement="bottomRight"
                      arrow={false}
                    >
                      <Button
                        shape="circle"
                        style={{
                          padding: "12px 12px 5px",
                          height: "auto",
                          backgroundColor: "#00a79d",
                        }}
                      >
                        <FaFilter
                          style={{ fontSize: "16px", color: "white" }}
                        />
                      </Button>
                    </Popover>
                    &emsp;
                    <Input
                      style={{ width: "250px" }}
                      className="mainInput dashInput"
                      placeholder="Search Here"
                      onChange={(e) => handleSearch(e.target.value)}
                      suffix={
                        <FaSearch
                          style={{
                            color: "grey",
                            fontSize: 16,
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            getLessons(
                              1,
                              paginationConfig.limit,
                              filter.keyword
                            )
                          }
                        />
                      }
                      onPressEnter={(e) =>
                        getLessons(1, paginationConfig.limit, filter.keyword)
                      }
                    />
                  </Col>
                </Row>

                <Row style={{ padding: 20, overflow: "auto" }}>
                  {loading ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <Skeleton active />
                      <br />
                    </div>
                  ) : (
                    <Table
                      className="styledTable"
                      dataSource={lessons}
                      columns={columns}
                      pagination={false}
                    />
                  )}
                </Row>
                <Row style={{ padding: "10px 20px" }}>
                  <Col xs={24} md={12}>
                    <p className="fontFamily1" style={{ color: "#999" }}>
                      {message}
                    </p>
                  </Col>
                  <Col
                    xs={24}
                    md={12}
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Pagination
                      className="styledPagination"
                      onChange={(e) => handlePageChange(e)}
                      current={parseInt(paginationConfig.pageNumber)}
                      pageSize={paginationConfig.limit}
                      total={paginationConfig.totalDocs}
                      itemRender={itemRender}
                    />
                  </Col>
                </Row>
                <br />
              </div>
            </Card>
          </div>
        </Col>
      </Row>

      {/* Quiz View/Download Modal */}
      <Modal
        title="Quiz Attempt Details"
        open={viewModalOpen}
        onCancel={handleCloseModal}
        width={1200}
        footer={[
          <Button key="close" onClick={handleCloseModal}>
            Close
          </Button>,
          <Button
            key="download"
            type="primary"
            icon={<FaDownload />}
            onClick={handleDownloadQuiz}
            style={{ backgroundColor: "#00a79d" }}
            loading={false}
          >
            Download PDF
          </Button>,
        ]}
      >
        <div
          id="quiz-print-content"
          style={{
            padding: "20px 40px",
            textAlign: "center",
            width: "100%",
            maxWidth: "100%",
          }}
        >
          {loadingQuizDetails ? (
            <div style={{ textAlign: "center", padding: "40px" }}>
              <Spin size="large" />
            </div>
          ) : selectedAttempt && quizDetails ? (
            <>
              {/* Certificate Layout */}
              <div
                className="certificate-container"
                style={{
                  border: "5px solid #00a79d",
                  borderStyle: "double",
                  padding: "60px 50px",
                  borderRadius: "15px",
                  position: "relative",
                  overflow: "hidden",
                  background: "linear-gradient(to bottom, #ffffff 0%, #f8fffe 100%)",
                  boxShadow: "0 4px 20px rgba(0,167,157,0.15)",
                  width: "100%",
                  maxWidth: "100%",
                  margin: "0 auto",
                }}
              >
                {/* Decorative border elements */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "6px",
                    background: "linear-gradient(90deg, #00a79d, #00d4c4, #00a79d)",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: "6px",
                    background: "linear-gradient(90deg, #00a79d, #00d4c4, #00a79d)",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background:
                      "radial-gradient(circle at top left, rgba(0,167,157,0.1), transparent 60%), radial-gradient(circle at bottom right, rgba(0,167,157,0.08), transparent 60%)",
                  }}
                />
                <div style={{ position: "relative", zIndex: 1 }}>
                  <div style={{ textAlign: "center", marginBottom: "30px" }}>
                    <Typography.Text
                      style={{
                        textTransform: "uppercase",
                        letterSpacing: "5px",
                        fontSize: "14px",
                        color: "#00a79d",
                        fontWeight: "600",
                      }}
                    >
                      WrightCo Academy
                    </Typography.Text>

                    <Typography.Title
                      level={2}
                      className="fontFamily1"
                      style={{
                        marginTop: "15px",
                        fontSize: "36px",
                        color: "#333d47",
                        fontWeight: "bold",
                        letterSpacing: "2px",
                      }}
                    >
                      Certificate of Achievement
                    </Typography.Title>
                  </div>

                  <div style={{ textAlign: "center", marginBottom: "35px" }}>
                    <Typography.Text
                      style={{
                        display: "block",
                        marginTop: "20px",
                        marginBottom: "15px",
                        color: "#555",
                        fontSize: "18px",
                        fontStyle: "italic",
                      }}
                    >
                      This is to certify that
                    </Typography.Text>

                  <Typography.Title
                    level={2}
                    className="fontFamily1"
                    style={{
                      marginBottom: "10px",
                      color: "#00a79d",
                      fontSize: "30px",
                      fontWeight: "bold",
                    }}
                  >
                    {user?.firstName && user?.lastName
                      ? `${user.firstName} ${user.lastName}`
                      : user?.name || user?.fullName || "Student"}
                  </Typography.Title>

                  <Typography.Text
                    style={{
                      display: "block",
                      marginBottom: "15px",
                      color: "#555",
                      fontSize: "16px",
                    }}
                  >
                    has successfully completed and passed the assessment
                  </Typography.Text>

                  <Typography.Title
                    level={3}
                    className="fontFamily1"
                    style={{ marginBottom: "10px", color: "#333d47", fontSize: "22px" }}
                  >
                    {quizDetails?.quiz?.title || "Quiz"}
                  </Typography.Title>

                  {quizDetails?.quiz?.course?.title && (
                    <Typography.Text
                      style={{
                        display: "block",
                        marginBottom: "25px",
                        color: "#666",
                        fontSize: "18px",
                        fontStyle: "italic",
                      }}
                    >
                      from the course: {quizDetails.quiz.course.title}
                    </Typography.Text>
                  )}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: "40px",
                      flexWrap: "wrap",
                      marginBottom: "30px",
                    }}
                  >
                    <div>
                      <Typography.Text
                        style={{ display: "block", color: "#888" }}
                      >
                        Score
                      </Typography.Text>
                      <Typography.Text
                        style={{
                          display: "block",
                          fontSize: "22px",
                          fontWeight: "bold",
                          color: "#00a79d",
                        }}
                      >
                        {selectedAttempt?.score}
                      </Typography.Text>
                    </div>
                    <div>
                      <Typography.Text
                        style={{ display: "block", color: "#888" }}
                      >
                        Passing Percentage
                      </Typography.Text>
                      <Typography.Text
                        style={{
                          display: "block",
                          fontSize: "22px",
                          fontWeight: "bold",
                          color: "#333d47",
                        }}
                      >
                        {selectedAttempt?.quiz?.passingPercentage}%
                      </Typography.Text>
                    </div>
                    <div>
                      <Typography.Text
                        style={{ display: "block", color: "#888" }}
                      >
                        Status
                      </Typography.Text>
                      <Typography.Text
                        style={{
                          display: "block",
                          fontSize: "22px",
                          fontWeight: "bold",
                          color:
                            selectedAttempt?.status === "PASS"
                              ? "green"
                              : "red",
                        }}
                      >
                        {selectedAttempt?.status}
                      </Typography.Text>
                    </div>
                  </div>

                  <div
                    style={{
                      marginTop: "30px",
                      marginBottom: "25px",
                      padding: "20px",
                      backgroundColor: "rgba(0,167,157,0.05)",
                      borderRadius: "8px",
                      borderLeft: "4px solid #00a79d",
                    }}
                  >
                    <Typography.Text
                      style={{
                        color: "#555",
                        fontSize: "16px",
                        display: "block",
                        lineHeight: "1.8",
                        textAlign: "center",
                      }}
                    >
                      This certificate is awarded in recognition of outstanding
                      performance and dedication to learning. The recipient has
                      demonstrated a thorough understanding of the course material
                      and achieved a passing score on the assessment, showcasing
                      commitment to professional development and educational excellence.
                    </Typography.Text>
                  </div>

                  <Typography.Text
                    style={{
                      color: "#888",
                      fontSize: "12px",
                      display: "block",
                      marginTop: "10px",
                      marginBottom: "30px",
                    }}
                  >
                    Certificate ID: #{selectedAttempt?.quiz?._id?.slice(-8) || "N/A"}
                  </Typography.Text>

                  <div
                    style={{
                      marginTop: "50px",
                      textAlign: "center",
                    }}
                  >
                    <Typography.Text
                      style={{
                        fontSize: "16px",
                        color: "#333d47",
                        fontWeight: "600",
                        display: "block",
                        marginBottom: "8px",
                      }}
                    >
                      Date Issued
                    </Typography.Text>
                    <Typography.Text
                      style={{
                        fontSize: "18px",
                        color: "#00a79d",
                        fontWeight: "bold",
                        display: "block",
                        marginBottom: "15px",
                      }}
                    >
                      {dayjs(selectedAttempt?.createdAt).format("DD MMMM, YYYY")}
                    </Typography.Text>
                    <div
                      style={{
                        borderTop: "2px solid #00a79d",
                        width: "250px",
                        margin: "0 auto",
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div style={{ textAlign: "center", padding: "40px" }}>
              <Typography.Text>No quiz data available</Typography.Text>
            </div>
          )}
        </div>
      </Modal>
    </Layout>
  );
}

export default AttemptedQuizzes;
